import { useEffect } from 'react';

import { resetMetadataResource, setMetadataResource } from 'core/telemetry/metadata';

import { useEnterpriseContext } from '../context/EnterpriseContext';

export const useTelemetryEnterpriseMetadata = () => {
  const enterprise = useEnterpriseContext();
  useEffect(() => {
    if (enterprise.enterprise) {
      setMetadataResource(enterprise.enterprise.id, 'enterprise');
    }
    return resetMetadataResource;
  });
};
